import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-toggle-switch-button',
  templateUrl: './toggle-switch-button.component.html',
  styleUrls: ['./toggle-switch-button.component.scss'],
})
export class ToggleSwitchButtonComponent {
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() captionText: string;
  @Input() size: 'sm' | 'lg' = 'lg';
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Output() change = new EventEmitter<MatSlideToggleChange>();

  public onChange = (event: MatSlideToggleChange) => {
    if (!this.disabled) {
      this.change.emit(event);
    }
  };
}
